<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <LegalAcknowledgementsOneFormFields v-model="formValues"></LegalAcknowledgementsOneFormFields>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import LegalAcknowledgementsOneFormFields from './acknowledgements/LegalAcknowledgementsOneFormFields.vue'
import { computed } from 'vue'
import { getLegalWidgetFormValidationRules, initializeLegalWidgetForm, LegalAcknowledgmentsOne } from './forms'
import { useVModel } from '@vueuse/core'
const formOneFields: string[] = Object.keys(new LegalAcknowledgmentsOne()).map((key) => 'acknowledgements.' + key)

const checkAll = computed({
    get() {
        return Object.keys(formValues.value)
            .filter((key) => Object.keys(new LegalAcknowledgmentsOne()).includes(key))
            .every((key) => {
                return formValues.value[key]
            })
    },
    // setter
    set(newValue) {
        console.log(formValues.value)
        if (newValue) {
            Object.keys(formValues.value)
                .filter((key) => Object.keys(new LegalAcknowledgmentsOne()).includes(key))
                .forEach((key) => {
                    formValues.value[key] = true
                })
        } else {
            Object.keys(formValues.value)
                .filter((key) => Object.keys(new LegalAcknowledgmentsOne()).includes(key))
                .forEach((key) => {
                    formValues.value[key] = false
                })
        }
    },
})

const props = defineProps<{
    modelValue: LegalAcknowledgmentsOne
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const allAcknowledgementRules = getLegalWidgetFormValidationRules('acknowledgements')

const acknowledgementsOneFormValidations = Object.keys(allAcknowledgementRules)
    .filter((key) => formOneFields.includes(key))
    .reduce((obj, key) => {
        obj[key] = allAcknowledgementRules[key]
        return obj
    }, {})

initializeLegalWidgetForm(acknowledgementsOneFormValidations)
</script>
